import { saveAs } from "file-saver";
import { Parser } from "json2csv";
import pick from "lodash/fp/pick";
class Controller {
  constructor($injector, $stateParams) {
    "ngInject";
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");

    this.activeParams = this.$stateParams;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.CorporateTransportationSubmissions = $injector.get(
      "CorporateTransportationSubmissions"
    );
    this.paginateEvent = this.Events.getPaginateEvent(
      "corporateTransportationSubmissions"
    );
  }

  $onInit() {
    this.exportCorporateSubmissions = () => {
      const jsonToCsvParser = new Parser();
      this.CorporateTransportationSubmissions.getAll({
        page: 1,
        limit: 0,
      }).$promise.then(
        (response) => {
          const fileName = "CorporateTransportationSubmissions.csv";
          const corporateSubmission = [];
          response.hits.map((submission) => {
            const formattedSubmission = pick(
              ["corporate_name", "contact_name", "phone_number"],
              submission
            );
            corporateSubmission.push(formattedSubmission);
            return corporateSubmission;
          });
          const csv = jsonToCsvParser.parse(corporateSubmission);
          const file = new File([csv], fileName);
          saveAs(file);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmissions/corporateTransportationSubmissions.controller.js